/**
 * @module Utilities/Strings
 * @desc Strings helper funtions
 */

/**
 * Pad a number with zeros
 */
export function pad(input: number, length = 2) {
  return `${input}`.padStart(length, '0');
}
